var faqPageMap = {
    "app": "https://www.telstra.com.au/support/category/mobiles-tablets/other/esim-faqs?ti=TR:TR:11022019:esim:support:link:pos1:unauth",
    "callback": "https://www.telstra.com.au/support/category/mobiles-tablets/other/esim-faqs?ti=TR:TR:11022019:esim:support:link:pos1:auth",
    "download": "https://www.telstra.com.au/support/category/mobiles-tablets/other/esim-faqs?ti=TR:TR:11022019:esim:support:link:pos1:auth",
    "downloadInitiated": "https://www.telstra.com.au/support/category/mobiles-tablets/other/esim-faqs?ti=TR:TR:11022019:esim:support:link:pos1:auth",
    "list": "https://www.telstra.com.au/support/category/mobiles-tablets/other/esim-faqs?ti=TR:TR:11022019:esim:support:link:pos1:iccidchoice",
    "userInfo": "https://www.telstra.com.au/support/category/mobiles-tablets/other/esim-faqs?ti=TR:TR:11022019:esim:support:link:pos1:auth",  
    "accountError": "https://www.telstra.com.au/support/category/mobiles-tablets/other/esim-faqs?ti=TR:TR:11022019:esim:support:link:pos1:invalidtdi",
    "DOWNLOAD_ERROR": "https://www.telstra.com.au/support/category/mobiles-tablets/other/esim-faqs?ti=TR:TR:11022019:esim:support:link:pos1:errorauth",
    "TROUBLESHOOT_ERROR": "https://www.telstra.com.au/support/category/mobiles-tablets/other/esim-faqs?ti=TR:TR:11022019:esim:support:link:pos1:errorauth",
    "ROUTE_ERROR": "https://www.telstra.com.au/support/category/mobiles-tablets/other/esim-faqs?ti=TR:TR:11022019:esim:support:link:pos1:invalideid"    
};

module.exports = {
    updateCurrentFAQ: function (pgeName, errorType) {
        let faqLink = faqPageMap[pgeName];
        // console.error("Page Name is "+ pgeName + " => Error Type is : " + errorType);
        if(pgeName.indexOf('error') !== -1) {
            faqLink = faqPageMap[errorType];
        }

        document.getElementById("faqLine").innerHTML = "<a href=\'" + faqLink + "\' target='_blank'>Go to FAQs > </a>";

        return faqLink;
    }
}



// WEBPACK FOOTER //
// ./src/analytics/faqTrack.js